// App.js
import React, { useEffect } from 'react';
import 'animate.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from './components/ThemeContext';
import { PermissionProvider } from './components/PermissionContext';
import Dashboard from './components/Dashboard';
import Register from './components/Register';
import Login from './components/Login';
import OTPVerification from './components/OTPVerification';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import EmployeeList from './components/EmployeeList';
import ProtectedRoute from './components/ProtectedRoute';
import CustomerList from './components/CustomerList';
import TemporaryCustomer from './components/TemporaryCustomer';
import Permission from './components/Permission';
import NoPermission from './components/NoPermission';
import AddCustomer from './components/AddCustomer';
import EditCustomer from './components/EditCustomer';
import PaymentList from './components/PaymentList';
import AddPayment from './components/AddPayment';
import Report from './components/Report';
import TodayReport from './components/TodayReport';
import WithdrawalList from './components/WithdrawalList';
import AddWithdrawal from './components/AddWithdrawal';
import LivePrice from './components/LivePrice';
import ShowroomRate from './components/ShowroomRate';
import Catalogue from './components/Catalogue';
import CatalogueGallery from './components/CatalogueGallery';
import { useParams } from 'react-router-dom';
import SessionExpiryModal from './utils/SessionExpiryModal';
function AppRoutes() {
  return (
    <Routes>
      {/* Default route → dashboard (ProtectedRoute will gate it) */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/otp-verification" element={<OTPVerification />} />
      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/EmployeeList"
        element={
          <ProtectedRoute requiredPermission="employee">
            <EmployeeList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CustomerList"
        element={
          <ProtectedRoute requiredPermission="customer">
            <CustomerList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TemporaryCustomer"
        element={
          <ProtectedRoute requiredPermission="customer">
            <TemporaryCustomer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/permission/:id"
        element={
          <ProtectedRoute requiredPermission="employee">
            <Permission />
          </ProtectedRoute>
        }
      />
      <Route path="/no-permission" element={<NoPermission />} />
      <Route
        path="/add-customer"
        element={
          <ProtectedRoute requiredPermission="customer">
            <AddCustomer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-customer/:id"
        element={
          <ProtectedRoute requiredPermission="customer">
            <EditCustomer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/PaymentList"
        element={
          <ProtectedRoute requiredPermission="payment">
            <PaymentList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/AddPayment"
        element={
          <ProtectedRoute requiredPermission="payment">
            <AddPayment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/WithdrawalList"
        element={
          <ProtectedRoute requiredPermission="payment">
            <WithdrawalList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/AddWithdrawal"
        element={
          <ProtectedRoute requiredPermission="payment">
            <AddWithdrawal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/report"
        element={
          <ProtectedRoute requiredPermission="report">
            <Report />
          </ProtectedRoute>
        }
      />
      <Route
        path="/today-report"
        element={
          <ProtectedRoute requiredPermission="report">
            <TodayReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/LivePrice"
        element={
          <ProtectedRoute>
            <LivePrice />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ShowroomRate"
        element={
          <ProtectedRoute>
            <ShowroomRate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Catalogue"
        element={
          <ProtectedRoute>
            <Catalogue />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Catalogue/:id"
        element={
          <ProtectedRoute>
            <CatalogueGallery  />
          </ProtectedRoute>
        }
      />
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function Layout() {
  const location = useLocation();
  // Hide layout only on public auth pages
  const hideLayout = ['/login', '/register', '/otp-verification'].includes(location.pathname);
  
  if (hideLayout) {
    return <AppRoutes />;
  }

  return (
    <div className="app-container">
      <Navbar />
      <div className="content-wrapper">
        <Sidebar />
        <main className="main-content">
          <AppRoutes />
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <PermissionProvider>
          <SessionExpiryModal />
          <Layout />
          <ToastContainer position="top-right" autoClose={3000} />
        </PermissionProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;